import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
} from "reactstrap";

import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import qrcode from "qrcode-js";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";
import fmtFecha from "../../../../utils/fmtFecha";

function ListadoVentas() {
  const { user } = useContext(AuthContext);
  const URL_SURTIDOS = import.meta.env.VITE_URL_SURTIDOS;
  const URL_CLIENTES = import.meta.env.VITE_URL_CLIENTES;
  const URL_SEND_MAIL_ATT = import.meta.env.VITE_URL_SEND_MAIL_ATT;
  const URL_ARTICULOS_PEDIDO = import.meta.env.VITE_URL_ARTICULOS_PEDIDO;
  const URL_ARTICULOS_SURTIDOS = import.meta.env.VITE_URL_ARTICULOS_SURTIDOS;
  const URL_DEPARTAMENTOS_CLIENTES =
    import.meta.env.VITE_URL_DEPARTAMENTOS_CLIENTES;
  const URL_FILEPOST = import.meta.env.VITE_URL_UPPROFILE;
  const URL_TRACKING_UPLOAD = import.meta.env.VITE_URL_UPTRACKING;
  const URL_LOGS = import.meta.env.VITE_URL_LOGS;
  const URL_WHATSAPP = import.meta.env.VITE_URL_WHATSAPP;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 30);

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");

  const [surtidos, setSurtidos] = useState([]);

  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [selectedUser, setSelectedUser] = useState("");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [departamentos, setDepartamentos] = useState([]);
  const [selectedDepartamento, setSelectedDepartamento] = useState("");

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [modalTracking, setModalTracking] = useState(false);
  const [trackingFile, setTrackingFile] = useState(null);
  const [trackingPreviewUrl, setTrackingPreviewUrl] = useState(null);
  const [isTrackingUploading, setIsTrackingUploading] = useState(false);
  const [trackingErrorMessage, setTrackingErrorMessage] = useState("");
  const [idVenta, setIdVenta] = useState(null);
  const [trackingPhoto, setTrackingPhoto] = useState("");
  const [nombre, setNombre] = useState("");
  const [telefono, setTelefono] = useState("");
  const [codigo, setCodigo] = useState("");

  const [activo, setActivo] = useState("");
  const [totalTotalTabla, setTotalTotalTabla] = useState(0);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useEffect(() => {
    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_DEPARTAMENTOS_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allDepartamentos = res.data;
        setDepartamentos(allDepartamentos);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useMemo(() => {
    axios
      .get(`${URL_SURTIDOS}Fechas/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allSurtidos = response.data;
        // Array para pagination
        let arrayTabla = allSurtidos
          .sort((a, b) => (a.idSurtido > b.idSurtido ? 1 : -1))
          .map((a) => {
            return {
              _id: a._id,
              is_active: a.is_active,
              fecha: a.fecha,
              user: a.user[0].nombre + " " + a.user[0].apellido,
              idUser: a.user[0]._id,
              pedidos: a.pedidos[0].idPedido,
              idPedido: a.pedidos[0]._id,
              clientes: a.pedidos[0].clientes[0].nombre_comercial,
              codigoClientes: a.pedidos[0].clientes[0].codigo,
              idClientes: a.pedidos[0].clientes[0]._id,
              telefono: a.pedidos[0].clientes[0].telefono,
              nombre: a.pedidos[0].clientes[0].nombre_comercial,
              observaciones: a.observaciones,
              observacionesPedido: a.pedidos[0].observaciones,
              numero: a.idSurtido,
              comisionTDC: a.pedidos[0].comisionTDC,
              comisionFlete: a.pedidos[0].comisionFlete,
              impuestos: a.pedidos[0].impuestos,
              subTotal: a.subTotal,
              iva: a.iva,
              total_general: a.total_general,
              calle: a.pedidos[0].clientes[0].calle,
              numero_ext: a.pedidos[0].clientes[0].numero_ext,
              numero_int: a.pedidos[0].clientes[0].numero_int,
              pais: a.pedidos[0].clientes[0].pais,
              estado: a.pedidos[0].clientes[0].estado,
              ciudad: a.pedidos[0].clientes[0].ciudad,
              delegacion: a.pedidos[0].clientes[0].delegacion,
              colonia: a.pedidos[0].clientes[0].colonia,
              cp: a.pedidos[0].clientes[0].cp,
              paqueteria: a.pedidos[0].paqueterias[0].name,
              idPaqueteria: a.pedidos[0].paqueterias[0]._id,
              RFC: a.pedidos[0].clientes[0].RFC,
              area: a.pedidos[0].areas[0].name,
              descuento: a.descuento,
              vendedor:
                a.pedidos[0].colaboradores[0].nombre +
                " " +
                a.pedidos[0].colaboradores[0].apellido,
              idDepartamento: a.clientes[0].departamentosClientes[0]._id,
              departamentoName: a.clientes[0].departamentosClientes[0].name,
              creado:
                a.pedidos[0].creado[0].nombre +
                " " +
                a.pedidos[0].creado[0].apellido,
              fechaHora:
                moment(a.createdAt).utcOffset("-0600").format("DD-MM-YYYY") +
                " " +
                moment(a.createdAt).utcOffset("-0600").format("HH:mm:ss"),
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);
        setSurtidos(allSurtidos);
        setComments(dataFinal);
        //
      })
      .catch((err) => {
        console.log(err);
      });
  }, [selectedFechaInicio, selectedFechaFin]);

  const ListaSurtidos = comments.sort((a, b) =>
    a.idSurtido > b.idSurtido ? 1 : -1
  );

  function PDFTabla() {
    let totalTotal = 0;
    const data = ListaSurtidos.map((a) => {
      totalTotal = totalTotal + a.total_general;
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (activo == 0 || activo == a.is_active) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes)
      ) {
        return [
          a.numero,
          a.fecha,
          a.clientes,
          a.area,
          a.vendedor,
          a.paqueteria,
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(a.comisionFlete),
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(a.total_general),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF({ compressPdf: true });
    var img = new Image();
    img.src = "Logo-Sistemify-PDF.png";
    doc.addImage(img, "png", 150, 5, 33, 10);
    var img2 = new Image();
    img2.src = "logoInstitucion.png";
    doc.addImage(img2, "png", 155, 15, 25, 25);
    doc.text(`Listado de Notas`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Numero",
          "Fecha",
          "Cliente",
          "Almacen",
          "Vendedor",
          "Paqueteria",
          "Flete",
          "Importe",
        ],
      ],
      body: dataPDFLimpia,
      startY: 50,
      foot: [
        [
          "",
          "",
          "",
          "",
          "",
          "",
          "Total",
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(totalTotal),
        ],
      ],
      showFoot: "lastPage",
    });
    doc.save(`Notas.pdf`);
  }

  function excel() {
    const dataExcel = ListaSurtidos.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (activo == 0 || activo == a.is_active) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes)
      ) {
        return {
          Numero: a.numero,
          Fecha: a.fecha,
          Cliente: a.clientes,
          Almacen: a.area,
          Vendedor: a.vendedor,
          Paqueteria: a.paqueteria,
          Flete: a.comisionFlete,
          Importe: a.total_general,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoNotas";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoNotas",
        sheetFilter: [
          "Numero",
          "Fecha",
          "Cliente",
          "Almacen",
          "Vendedor",
          "Paqueteria",
          "Flete",
          "Importe",
        ],
        sheetHeader: [
          "Numero",
          "Fecha",
          "Cliente",
          "Almacen",
          "Vendedor",
          "Paqueteria",
          "Flete",
          "Importe",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    let totalTotal = 0;
    const data = ListaSurtidos.map((a) => {
      totalTotal = totalTotal + a.total_general;
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (activo == 0 || activo == a.is_active) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes)
      ) {
        return [
          a.numero,
          a.fecha,
          a.clientes,
          a.area,
          a.vendedor,
          a.paqueteria,
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(a.comisionFlete),
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(a.total_general),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF({ compressPdf: true });
    var img = new Image();
    img.src = "Logo-Sistemify-PDF.png";
    doc.addImage(img, "png", 150, 5, 33, 10);
    var img2 = new Image();
    img2.src = "logoInstitucion.png";
    doc.addImage(img2, "png", 155, 15, 25, 25);
    doc.text(`Listado de Notas`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Numero",
          "Fecha",
          "Cliente",
          "Almacen",
          "Vendedor",
          "Paqueteria",
          "flete",
          "Importe",
        ],
      ],
      body: dataPDFLimpia,
      startY: 50,
      foot: [
        [
          "",
          "",
          "",
          "",
          "",
          "",
          "Total",
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(totalTotal),
        ],
      ],
      showFoot: "lastPage",
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado de Notas",
          email: mailTo,
          fileName: "ListadoNotas.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${import.meta.env.VITE_TAMANO_LOGO_MAIL}" align="center" src="${import.meta.env.VITE_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${import.meta.env.VITE_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Notas.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${import.meta.env.VITE_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://sistemify.com"> <img width="20%" align="center" src="${import.meta.env.VITE_LINK_SISTEMA}Logo-Sistemify-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
        });
        console.log(error);
      });
  }

  function cancelarNota(idNota) {
    Swal.fire({
      title: "Estas seguro?",
      text: "Se cancelara la Nota!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Cancelar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .get(`${URL_SURTIDOS}Cancel/${idNota}`, {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then(() => {
            Swal.fire("Good job!", "Enviado con exito", "success");
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
            });
            console.log(error);
          });
      }
    });
  }

  async function PDFOC(
    fecha,
    idClientes,
    clientes,
    observaciones,
    observacionesPedido,
    numero,
    idPDFOC,
    user,
    pedidos,
    comisionTDC,
    comisionFlete,
    impuestos,
    subTotal,
    iva,
    total_general,
    calle,
    numero_ext,
    numero_int,
    pais,
    estado,
    ciudad,
    delegacion,
    colonia,
    cp,
    RFC,
    paqueteria,
    area,
    codigoClientes,
    vendedor,
    telefono,
    creado,
    fechaHora,
    descuento,
    is_active
  ) {
    await axios
      .get(`${URL_ARTICULOS_SURTIDOS}/surtido/${idPDFOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosSurtido = response.data;
        let arrayTabla = allArticulosSurtido
          .map((a) => {
            return {
              id: a.inventarios[0]._id,
              articulos: a.articulos[0].codigo + " " + a.articulos[0].nombre,
              cantidad: a.cantidad,
              idArticulo: a.articulos[0]._id,
              precio: a.articulosPedido[0].precio,
              cajas: a.cantidad / a.articulos[0].piezasPorCaja,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        let totalMts = dataFinal.map((c) => parseFloat(c.cantidad));
        let TM = totalMts.reduce((t, total, index) => t + total, 0);

        let TC = dataFinal.map((c) => parseFloat(c.cajas));
        let TTC = TC.reduce((t, total, index) => t + total, 0);

        let temp1 = (subTotal * descuento) / 100;

        let totalParcial = 0;

        const data = dataFinal
          .sort((a, b) => (a.articulos > b.articulos ? 1 : -1))
          .map((a) => {
            totalParcial = a.cantidad * a.precio;
            return [
              a.articulos,
              new Intl.NumberFormat("en-US").format(a.cantidad),
              new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
              }).format(a.precio),
              new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
              }).format(totalParcial),
            ];
          });

        const dataPDF = Object.values(data);
        const dataPDFLimpia = dataPDF.filter(function (el) {
          return el != null;
        });
        const doc = new jsPDF({ compressPdf: true });
        var img = new Image();
        img.src = "Logo-Sistemify-PDF.png";
        doc.addImage(img, "png", 8, 15, 18, 5);
        var img2 = new Image();
        img2.src = "logoInstitucion.png";
        doc.addImage(img2, "png", 10, 21, 15, 15);

        let alto = 5;

        doc.setFontSize(12);
        doc.text(`Fecha:`, 35, alto + 15);
        doc.text(`${fecha}`, 60, alto + 15);
        doc.text(`Nota:`, 35, alto + 20);
        doc.text(`${numero}`, 60, alto + 20);
        doc.text(`Pedido:`, 35, alto + 25);
        doc.text(`${pedidos}`, 60, alto + 25);

        doc.text(`Ejecutivo:`, 120, alto + 15);
        doc.text(`${vendedor}`, 150, alto + 15);

        doc.setFontSize(8);
        doc.text(`Creado por: ${creado}`, 120, alto + 32);
        doc.text(`Fecha creado: ${fechaHora}`, 120, alto + 37);

        doc.text(`Cliente: ${codigoClientes} - ${clientes}`, 10, alto + 32);
        doc.text(`RFC: ${RFC}`, 10, alto + 37);
        doc.text(
          `Direccion de Envio: ${calle} #${numero_ext} Int. ${numero_int}`,
          10,
          alto + 47
        );
        doc.text(`Telefono: ${telefono}`, 10, alto + 52);
        doc.text(`Edo: ${estado}, Ciudad: ${ciudad}, CP: ${cp}`, 10, alto + 57);
        doc.text(`Del: ${delegacion}, Col: ${colonia}`, 10, alto + 62);

        doc.setFontSize(12);
        doc.text(`Paqueteria: ${paqueteria}`, 120, alto + 50);
        doc.text(`Almacen: ${area}`, 120, alto + 57);

        if (is_active == "Si") {
          // DEBUG: Log footer concatenation format
          const cajasFormatted = new Intl.NumberFormat("en-US").format(TTC.toFixed(2));
          const piezasFormatted = new Intl.NumberFormat("en-US").format(TM);

          doc.autoTable({
            head: [["Articulo", "Cantidad", "Precio", "Total"]],
            body: dataPDFLimpia,
            styles: {
              fontSize: 12,
              // overflow: "linebreak",
              // columnWidth: "wrap",
              // // font: 'arial',
              // overflowColumns: "linebreak",
            },
            margin: { left: 7, right: 7 },
            startY: alto + 70,
            foot: [
              [
                "",
                `${piezasFormatted} Piezas`,
                "Sub Total",
                new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  maximumFractionDigits: 2,
                }).format(subTotal.toFixed(2)),
              ],
              [
                "",
                "",
                `Comision`,
                new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  maximumFractionDigits: 2,
                }).format(iva.toFixed(2)),
              ],
              [
                "",
                "",
                "Comision TDC",
                new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  maximumFractionDigits: 2,
                }).format(comisionTDC.toFixed(2)),
              ],
              [
                "",
                "",
                "Flete",
                new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  maximumFractionDigits: 2,
                }).format(comisionFlete.toFixed(2)),
              ],
              [
                "",
                "",
                `Desc ${descuento}%`,
                new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  maximumFractionDigits: 2,
                }).format((-temp1).toFixed(2)),
              ],
              [
                "",
                "",
                "Total",
                new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  maximumFractionDigits: 2,
                }).format(total_general.toFixed(2)),
              ],
            ],
            showFoot: "lastPage",
          });
        } else {
          doc.autoTable({
            head: [["Articulo","Cantidad", "Precio", "Total"]],
            body: dataPDFLimpia,
            styles: {
              fontSize: 12,
              // overflow: "linebreak",
              // columnWidth: "wrap",
              // // font: 'arial',
              // overflowColumns: "linebreak",
            },
            margin: { left: 7, right: 7 },
            startY: alto + 70,
            foot: [["", "", "", "", "CANCELADA"]],
          });
        }
        var lines = doc.splitTextToSize(
          `Observaciones ${observacionesPedido}`,
          200
        );
        doc.text(10, doc.autoTable.previous.finalY + 10, lines);

        // doc.save(`Nota-${numero}.pdf`);
        window.open(doc.output("bloburl"), "_blank");
        
        //   }
        // });
        // });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function PDFOCTicket(idPDFOC, consecutivo, prefijo) {
    try {
      // Format fecha to Mexican style (always today)
      const fechaMex = moment().format("DD/MM/YYYY");
      const hora = moment().format("HH:mm");

      // Get articulos surtidos data with colors and tallas
      const response = await axios.get(`${URL_ARTICULOS_SURTIDOS}/surtido/${idPDFOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      });

      let allArticulosSurtido = response.data;
      let arrayTabla = allArticulosSurtido
        .map((a) => {
          return {
            id: a.inventarios[0]._id,
            articulos: a.articulos[0].codigo + " " + a.articulos[0].nombre,
            colorNombre: a.colores && a.colores.length > 0 ? a.colores[0].name : "",
            tallaNombre: a.tallas && a.tallas.length > 0 ? a.tallas[0].name : "",
            cantidad: a.cantidad,
            idArticulo: a.articulos[0]._id,
            precio: a.articulosPedido[0].precio,
            total: a.cantidad * a.articulosPedido[0].precio,
            cajas: a.cantidad / a.articulos[0].piezasPorCaja,
          };
        })
        .filter(function (el) {
          return el != null;
        });

      let dataFinal = Object.values(arrayTabla);

      // Group by article ID to consolidate same articles
      let agrupado = dataFinal.reduce(function (groups, item) {
        const val = item["idArticulo"];
        groups[val] = groups[val] || {
          idArticulo: item.idArticulo,
          cantidad: 0,
          total: 0,
          cajas: 0,
        };
        groups[val].cantidad += item.cantidad;
        groups[val].cajas += item.cajas;
        groups[val].articulos = item.articulos;
        groups[val].colorNombre = item.colorNombre;
        groups[val].tallaNombre = item.tallaNombre;
        groups[val].precio = item.precio;
        groups[val].total += item.total;
        return groups;
      }, []);

      let dataAgrupado = Object.values(agrupado);

      // Process data for table - truncate long names and format properly
      const data = dataAgrupado
        .sort((a, b) => (a.articulos > b.articulos ? 1 : -1))
        .map((a) => {
          // Truncate item name if too long (max 24 chars for 8cm width)
          const itemName =
            a.articulos.length > 24
              ? a.articulos.substring(0, 21) + "..."
              : a.articulos;

          return [
            itemName,
            a.colorNombre || "",
            a.tallaNombre || "",
            a.cantidad.toString(),
            `$${a.precio.toFixed(2)}`,
            `$${a.total.toFixed(2)}`,
          ];
        });

      const dataPDF = Object.values(data);
      const dataPDFLimpia = dataPDF.filter(function (el) {
        return el != null;
      });

      // Calculate dynamic height based on content
      const baseHeight = 18; // Base height in cm
      const itemHeight = 0.5; // Height per item in cm
      const headerHeight = 8; // Height for header section
      const footerHeight = 12; // Height for footer, totals, payments (more for payment methods)
      const bufferHeight = 4; // Extra space at the end for cutting

      const totalHeight =
        headerHeight +
        dataPDFLimpia.length * itemHeight +
        footerHeight +
        bufferHeight;

      // Create PDF with proper thermal dimensions (8cm width) and calculated height
      const doc = new jsPDF("p", "cm", [8, totalHeight], true);

      // Generate QR code
      var base64 = await qrcode.toDataURL(idPDFOC);
      var img3 = new Image();
      img3.src = base64;

      var img2 = new Image();
      img2.src = "logoInstitucion.png";

      // HEADER SECTION with yPos tracking
      const centerX = 4; // Center of 8cm width
      const leftMargin = 0.2;
      const rightMargin = 7.8;
      let yPos = 0.3; // Start position

      // Logo
      doc.addImage(img2, "png", 6.5, yPos, 1.2, 0.8);
      yPos += 1.0; // Space after logo

      // Business information - centered with better spacing
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      doc.text(`${import.meta.env.VITE_NOMBRE_INSTITUCION}`, centerX, yPos, {
        align: "center",
      });
      yPos += 0.5; // More space after business name

      doc.setFont("helvetica", "normal");
      doc.setFontSize(7);
      doc.text("CALLE ##, COLONIA", centerX, yPos, {
        align: "center",
      });
      yPos += 0.35; // More space between address lines

      doc.text("CIUDAD, ESTADO CP", centerX, yPos, {
        align: "center",
      });
      yPos += 0.35; // More space between address lines

      doc.text(`RFC:`, centerX, yPos, { align: "center" });
      yPos += 0.35; // More space after RFC

      doc.text("General de Ley de Personas Morales", centerX, yPos, {
        align: "center",
      });
      yPos += 0.5; // More space before separator

      // Separator line
      doc.setLineWidth(0.01);
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 0.5; // More space after separator

      // Store information with better spacing
      doc.setFontSize(8);
      doc.text(`Tienda: ${user.areaName}`, centerX, yPos, {
        align: "center",
      });
      yPos += 0.35; // More space between store info lines

      doc.text(`Direccion: ${user.areaDireccion}`, centerX, yPos, {
        align: "center",
      });
      yPos += 0.35; // More space between store info lines

      doc.text(`Telefono: ${user.areaTelefono}`, centerX, yPos, {
        align: "center",
      });
      yPos += 0.5; // More space before separator

      // Another separator
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 0.5; // More space after separator

      // Transaction information with better spacing
      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.text(`Fecha: ${fechaMex} ${hora}`, centerX, yPos, { align: "center" });
      yPos += 0.4; // More space after date

      doc.setFont("helvetica", "normal");
      doc.text(
        `Venta: ${prefijo}-${consecutivo}`,
        centerX,
        yPos,
        { align: "center" }
      );
      yPos += 0.6; // Much more space before final separator

      // Final separator before items
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 0.6; // Much more space before table starts

      // ITEMS TABLE with proper column widths for 8cm (4 columns)
      doc.autoTable({
        head: [["Articulo", "Color", "Talla", "Can", "Precio", "Total"]],
        body: dataPDFLimpia,
        startY: yPos, // Use yPos instead of fixed value

        // Fixed column widths that total to ~7.6cm (leaving margins) - 4 columns
        columnStyles: {
          0: {
            cellWidth: 2, // Item name (largest)
            halign: "left",
            overflow: "linebreak",
            fontSize: 7,
          },
          1: {
            cellWidth: 1, // Color
            halign: "left",
            overflow: "hidden",
            fontSize: 7,
          },
          2: {
            cellWidth: 1, // Talla
            halign: "left",
            overflow: "hidden",
            fontSize: 7,
          },
          3: {
            cellWidth: 0.8, // Cantidad
            halign: "center",
            overflow: "hidden",
            fontSize: 7,
          },
          4: {
            cellWidth: 1.3, // Precio
            halign: "right",
            overflow: "linebreak",
            fontSize: 6,
          },
          5: {
            cellWidth: 1.5, // Total
            halign: "right",
            overflow: "linebreak",
            fontSize: 6,
          },
        },

        styles: {
          fontSize: 8,
          font: "helvetica",
          cellPadding: { top: 0.2, right: 0.1, bottom: 0.2, left: 0.1 }, // More vertical padding
          lineWidth: 0.01,
          lineColor: [180, 180, 180],
          textColor: [0, 0, 0],
          overflow: "linebreak",
        },

        headStyles: {
          fontStyle: "bold",
          fontSize: 9,
          fillColor: [245, 245, 245],
          textColor: [0, 0, 0],
          halign: "center",
          cellPadding: { top: 0.25, right: 0.1, bottom: 0.25, left: 0.1 }, // More padding in header
        },

        margin: { left: leftMargin, right: leftMargin },
        tableWidth: "wrap",
        theme: "grid",
      });

      // Get the Y position after the table with much more space
      yPos = doc.lastAutoTable.finalY + 0.8; // Much more space after table

      // TOTALS SECTION
      doc.setLineWidth(0.02);
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 0.4; // More space after line

      // Calculate totals from dataAgrupado
      const subTotal = dataAgrupado.reduce((sum, item) => sum + item.total, 0);
      const totalPiezas = dataAgrupado.reduce((sum, item) => sum + item.cantidad, 0);
      const total_general = subTotal; // Assuming no discount for ventas

      // Subtotal, total with better spacing and simpler formatting
      doc.setFont("helvetica", "normal");
      doc.setFontSize(9);

      const totalsX = 3.8; // Move labels more to the left for better spacing

      // Add total pieces line
      doc.text("Total Piezas:", totalsX, yPos);
      doc.text(`${totalPiezas}`, rightMargin - 0.1, yPos, {
        align: "right",
      });
      yPos += 0.35; // More space between lines

      doc.text("SubTotal:", totalsX, yPos);
      doc.text(`$${subTotal.toFixed(2)}`, rightMargin - 0.1, yPos, {
        align: "right",
      });
      yPos += 0.35; // More space between lines

      // Separator line before total
      doc.setLineWidth(0.01);
      yPos += 0.25;

      // Total with emphasis
      doc.setFont("helvetica", "bold");
      doc.setFontSize(11);

      const totalLabelX = 3.5;
      doc.text("TOTAL:", totalLabelX, yPos);
      doc.text(`$${total_general.toFixed(2)}`, rightMargin - 0.1, yPos, {
        align: "right",
      });
      yPos += 0.8; // More space after total

      // FOOTER with more spacing
      yPos += 0.3;
      doc.setLineWidth(0.01);
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 0.4;

      // Store policies - centered
      doc.setFont("helvetica", "bold");
      doc.setFontSize(7);
      doc.text("POLÍTICAS DE LA TIENDA", centerX, yPos, {
        align: "center",
      });
      yPos += 0.5;

      doc.setFont("helvetica", "normal");
      doc.setFontSize(6);

      const policies = [
        "**** NO ES UN COMPROBANTE FISCAL ****",
        "NO SE ACEPTAN CAMBIOS NI DEVOLUCIONES",
        "NI POR DEFECTO",
        "**** GRACIAS POR SU PREFERENCIA ****",
      ];

      policies.forEach((line) => {
        doc.text(line, centerX, yPos, { align: "center" });
        yPos += 0.25;
      });

      yPos += 0.4;
      doc.setFont("helvetica", "normal");
      doc.setFontSize(7);
      doc.text("¡Gracias por su compra!", centerX, yPos, {
        align: "center",
      });
      yPos += 0.25;
      doc.text("Conserve este comprobante", centerX, yPos, {
        align: "center",
      });
      yPos += 0.4;

      // WhatsApp customer service info
      doc.setFont("helvetica", "bold");
      doc.setFontSize(6);
      doc.text("WhatsApp Atención a clientes:", centerX, yPos, {
        align: "center",
      });
      yPos += 0.25;
      doc.setFont("helvetica", "normal");
      doc.text("495 103 6208 & 495 101 1713", centerX, yPos, {
        align: "center",
      });
      yPos += 0.4;

      // QR code - properly centered
      const qrSize = 1.6;
      doc.addImage(img3, "png", centerX - qrSize / 2, yPos, qrSize, qrSize);

      // Save and print
      doc.autoPrint();
      window.open(doc.output("bloburl"), "_blank");

      var att = doc.output("arraybuffer");

      let params = new URLSearchParams({
        number: "1234567890", // Default phone number since we don't have customer data
        message: `Hola, Gracias por confiar en ${
          import.meta.env.VITE_NOMBRE_INSTITUCION
        }, estamos para servirle!
      Cualquier duda estamos a tu órdenes!
      Bendiciones que tenga buena venta!`,
        fileName: `Venta-${prefijo}${consecutivo}.pdf`,
        mimetype: "application/pdf",
      });

      // Try to send via WhatsApp, but don't show errors if WhatsApp is not configured
      axios
        .post(`${URL_WHATSAPP}SendPDFFront?${params.toString()}`, att, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            "Content-Type": "application/octet-stream",
          },
        })
        .then(() => {
          // WhatsApp sent successfully (optional success message)
          console.log("PDF sent via WhatsApp successfully");
        })
        .catch((error) => {
          // Silently handle WhatsApp errors - don't show error to user
          console.log("WhatsApp service not available or not configured:", error.message);
          // PDF was still generated successfully, so no user error needed
        });
    } catch (error) {
      console.error("Error generating PDF:", error);
      Swal.fire({
        icon: "error",
        title: "Error generando PDF",
        text: "Hubo un problema al generar el PDF",
      });
    }
  }

  const headers = [
    { name: "Numero", field: "numero", sortable: true },
    { name: "Fecha", field: "fecha", sortable: true },
    { name: "Cliente", field: "clientes", sortable: true },
    { name: "Almacen", field: "area", sortable: true },
    { name: "Vendedor", field: "vendedor", sortable: true },
    { name: "Paqueteria", field: "paqueteria", sortable: true },
    { name: "Flete", field: "comisionFlete", sortable: true },
    { name: "Total", field: "total_general", sortable: true },
    { name: "Detalles", field: "acciones", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.clientes.toLowerCase().includes(search.toLowerCase()) ||
          comment.area.toLowerCase().includes(search.toLowerCase()) ||
          comment.vendedor.toLowerCase().includes(search.toLowerCase()) ||
          comment.paqueteria.toLowerCase().includes(search.toLowerCase()) ||
          comment.pedidos.toString().includes(search) ||
          comment.numero.toString().includes(search) ||
          comment.total_general.toString().includes(search) ||
          comment.comisionFlete.toString().includes(search)
      );
    }
    if (selectedCliente) {
      computedComments = computedComments.filter((e) =>
        e.idClientes.includes(selectedCliente)
      );
    }
    if (selectedUser) {
      computedComments = computedComments.filter((e) =>
        e.idUser.includes(selectedUser)
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }
    // if (selectedDepartamento) {
    //   computedComments = computedComments.filter((e) =>
    //     e.idDepartamento.includes(selectedDepartamento)
    //   );
    // }

    let activos = computedComments.filter((e) => e.is_active == "Si");
    let t = activos.map((c) => parseFloat(c.total_general));
    let Tt = t.reduce((t, cantidad, index) => t + cantidad, 0);
    setTotalTotalTabla(Tt);

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "pedidos" &&
      sorting.field != "numero" &&
      sorting.field != "comisionFlete" &&
      sorting.field != "total_general"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "pedidos" ||
        sorting.field == "numero" ||
        sorting.field == "comisionFlete" ||
        sorting.field == "total_general")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "pedidos" ||
        sorting.field == "numero" ||
        sorting.field == "comisionFlete" ||
        sorting.field == "total_general")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedCliente,
    selectedUser,
    selectedFechaInicio,
    selectedFechaFin,
    // selectedDepartamento,
  ]);

  let totalImporteTabla = 0;

  // Toggle function for the modal
  const toggleTrackingModal = () => {
    setModalTracking(!modalTracking);
    if (modalTracking) {
      // Reset state when closing
      setTrackingFile(null);
      setTrackingPreviewUrl(null);
      setTrackingErrorMessage("");
    }
  };
  const checkTrackingImage = (ventaId) => {
    setTrackingPhoto("");
    const URL_GET_TRACKING = `${import.meta.env.VITE_URL_GETMEDIA}/${ventaId}`;
    axios
      .get(URL_GET_TRACKING, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        console.log(data);
        if (data.data.url) {
          console.log(data.data.url);
          setTrackingPhoto(data.data.url);
        }
      })
      .catch((error) => {
        console.error("Error loading tracking image:", error);
      });
  };

  const handleTrackingFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      // Check if file is an image or PDF
      const isImage = selectedFile.type.startsWith("image/");
      const isPDF = selectedFile.type === "application/pdf";
      
      if (!isImage && !isPDF) {
        setTrackingErrorMessage(
          "Por favor seleccione un archivo de imagen o PDF válido."
        );
        return;
      }
      
      // Check file size (limit to 10MB for PDFs, 5MB for images)
      const maxSize = isPDF ? 10 * 1024 * 1024 : 5 * 1024 * 1024;
      if (selectedFile.size > maxSize) {
        setTrackingErrorMessage(
          `El archivo no debe superar los ${isPDF ? '10MB' : '5MB'}.`
        );
        return;
      }
      
      setTrackingFile(selectedFile);
      setTrackingPreviewUrl(URL.createObjectURL(selectedFile));
      setTrackingErrorMessage("");
    }
  };

  // Handle file upload
  const handleTrackingUpload = async () => {
    if (!trackingFile) {
      setTrackingErrorMessage(
        "Por favor seleccione una imagen o PDF del número de seguimiento."
      );
      return;
    }
    
    setIsTrackingUploading(true);
    setTrackingErrorMessage("");
    
    try {
      const isImage = trackingFile.type.startsWith("image/");
      const isPDF = trackingFile.type === "application/pdf";
      
      // 1. Upload the tracking file using the new endpoint
      const formData = new FormData();
      formData.append("file", trackingFile);
      formData.append("articulo", idVenta);
      
      const response = await axios.post(URL_TRACKING_UPLOAD || URL_FILEPOST, formData, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      });
      
      const fileUrl = response.data.secure_url;
      
      // 2. Log the action
      await axios.post(
        URL_LOGS,
        {
          tipo: isPDF ? "Subir PDF Tracking" : "Subir Imagen Tracking",
          detalle: `Tracking para venta ID: ${idVenta}`,
          user: user.id,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );
      
      // 3. Generate base PDF with client information
      const doc = new jsPDF();
      
      // Set up the base PDF
      doc.setFontSize(16);
      doc.text(`${import.meta.env.VITE_NOMBRE_INSTITUCION}`, 105, 20, {
        align: "center",
      });
      doc.setFontSize(14);
      doc.text("Información de Seguimiento", 105, 30, { align: "center" });
      doc.setFontSize(12);
      doc.text(`Código: ${codigo}`, 20, 45);
      doc.text(`Cliente: ${nombre}`, 20, 55);
      doc.text(`Fecha: ${new Date().toLocaleDateString()}`, 20, 65);
      
      // 4. Handle different file types
      if (isImage) {
        // Handle image files (existing logic)
        const imgData = await fetch(fileUrl);
        const imgBlob = await imgData.blob();
        
        const reader = new FileReader();
        const imageDataPromise = new Promise((resolve) => {
          reader.onload = function (event) {
            resolve(event.target.result);
          };
          reader.readAsDataURL(imgBlob);
        });
        
        const imageData = await imageDataPromise;
        doc.addImage(imageData, "JPEG", 20, 80, 170, 120);
        
      } else if (isPDF) {
        // Handle PDF files - send 2 separate files
        console.log('Processing PDF upload - will send 2 separate files');
        
        // Generate base PDF with client info (NO terms page)
        doc.text("PDF de seguimiento adjunto por separado", 105, 210, { align: "center" });
        doc.autoPrint();
        const basePdfData = doc.output("arraybuffer");
        
        // Send both PDFs via WhatsApp
        const URL_WHATSAPP = import.meta.env.VITE_URL_WHATSAPP;
        
        if (!URL_WHATSAPP) {
          throw new Error('URL de WhatsApp no configurada (VITE_URL_WHATSAPP)');
        }
        
        try {
          // 1. Send the base PDF with client info
          console.log('Sending client info PDF...');
          
          let params1 = new URLSearchParams({
            number: telefono,
            message: `Información de seguimiento para ${codigo}`,
            fileName: `Info-${codigo}.pdf`,
            mimetype: "application/pdf",
          });
          
          await axios.post(
            `${URL_WHATSAPP}SendPDFFront?${params1.toString()}`,
            basePdfData,
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                "Content-Type": "application/octet-stream",
              },
            }
          );
          
          // 2. Send the original PDF directly using the file from the form
          console.log('Sending original PDF file directly...');
          
          // Create FormData with the original file
          const formData = new FormData();
          formData.append('file', trackingFile);
          formData.append('number', telefono);
          formData.append('message', `PDF de tracking para ${codigo}`);
          formData.append('fileName', `Tracking-${codigo}.pdf`);
          
          // Send the original file directly without re-downloading
          await axios.post(
            `${URL_WHATSAPP}SendPDFFromForm`,
            formData,
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                "Content-Type": "multipart/form-data",
              },
            }
          );
          
          // Success - close modal
          setIsTrackingUploading(false);
          toggleTrackingModal();
          
          Swal.fire({
            icon: "success",
            title: "Éxito",
            text: "Archivos de tracking enviados por WhatsApp correctamente (2 archivos separados)",
          });
          
          return; // Exit here since we already sent everything
          
        } catch (whatsappError) {
          console.error('Error sending PDF files:', whatsappError);
          
          // Fallback: try sending with the ArrayBuffer method
          console.log('Trying fallback method with ArrayBuffer...');
          try {
            const reader = new FileReader();
            const fileDataPromise = new Promise((resolve) => {
              reader.onload = function(event) {
                resolve(event.target.result);
              };
              reader.readAsArrayBuffer(trackingFile);
            });
            
            const originalPdfData = await fileDataPromise;
            
            let params2 = new URLSearchParams({
              number: telefono,
              message: `PDF de tracking para ${codigo}`,
              fileName: `Tracking-${codigo}.pdf`,
              mimetype: "application/pdf",
            });
            
            await axios.post(
              `${URL_WHATSAPP}whatsAppSendPDFFront?${params2.toString()}`,
              originalPdfData,
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  "Content-Type": "application/octet-stream",
                },
              }
            );
            
            // Success - close modal
            setIsTrackingUploading(false);
            toggleTrackingModal();
            
            Swal.fire({
              icon: "success",
              title: "Éxito",
              text: "Archivos de tracking enviados por WhatsApp correctamente (método fallback)",
            });
            
            return;
            
          } catch (fallbackError) {
            console.error('Fallback method also failed:', fallbackError);
            throw new Error(`Error enviando archivos: ${whatsappError.message}`);
          }
        }
      }
      
      // Only add "Gracias por su compra" and terms for image uploads
      if (isImage) {
        doc.text("Gracias por su compra", 105, 210, { align: "center" });
        
        // Prepare final PDF for sending
        doc.autoPrint();
        var att = doc.output("arraybuffer");
      }
      
      // 6. Ensure PDF data is ready for sending
      let finalPdfData;
      
      if (typeof att === 'undefined') {
        console.warn('PDF data not defined, generating fallback PDF');
        doc.autoPrint();
        finalPdfData = doc.output("arraybuffer");
      } else {
        finalPdfData = att;
      }
      
      // 7. Send the PDF through WhatsApp
      let params = new URLSearchParams({
        number: telefono,
        message: `Gracias Por tu compra✨🫶🏼 espero que toda la mercancia sea de tu agrado, tus prendas fueron revisadas conforme a tu pedido para evitar cualquier inconveniente😉 Te pido grabar video al desempacar tu mercancia para cualquier aclaración   quedo a tus ordenes para cualquier duda y futuros pedidos✍`,
        fileName: `Tracking-${codigo}.pdf`,
        mimetype: "application/pdf",
      });
      
      const URL_WHATSAPP = import.meta.env.VITE_URL_WHATSAPP;
      
      console.log('Sending PDF via WhatsApp:', {
        url: `${URL_WHATSAPP}SendPDFFront`,
        fileSize: finalPdfData.byteLength,
        fileName: `Tracking-${codigo}.pdf`,
        fileType: isPDF ? 'PDF' : 'Image',
        telefono: telefono
      });
      
      if (!URL_WHATSAPP) {
        throw new Error('URL de WhatsApp no configurada (VITE_URL_WHATSAPP)');
      }
      
      await axios.post(
        `${URL_WHATSAPP}SendPDFFront?${params.toString()}`,
        finalPdfData,
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            "Content-Type": "application/octet-stream",
          },
        }
      );
      
      // Success - close modal
      setIsTrackingUploading(false);
      toggleTrackingModal();
      
      // Show success message
      Swal.fire({
        icon: "success",
        title: "Éxito",
        text: `${isPDF ? 'PDF' : 'Imagen'} de tracking subido y enviado por WhatsApp correctamente`,
      });
    } catch (error) {
      setIsTrackingUploading(false);
      setTrackingErrorMessage(
        "Error al subir el archivo. Por favor intente nuevamente."
      );
      console.error("Error uploading tracking file:", error);
      
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Error al procesar la solicitud",
        footer: error.response ? `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}` : "Error de conexión",
      });
    }
  };

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_ventas ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              <Button
                size="sm"
                href="/MenuAdmin"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i className="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i className="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i className="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado de Notas</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align="center">Ventas</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label>Clientes</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedCliente}
                onChange={(e) => {
                  setSelectedCliente(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="0">Selecciona</option>
                {clientes
                  .sort((a, b) =>
                    a.nombre_comercial > b.nombre_comercial ? 1 : -1
                  )
                  .map((a) => {
                    return <option value={a._id}>{a.nombre_comercial}</option>;
                  })}
              </Input>
            </Col>
            {/* <Col md={2}>
                <Label>Departamento</Label>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedDepartamento}
                  onChange={(e) => {
                    setSelectedDepartamento(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {departamentos
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </Col> */}
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((a) => {
                if (a.is_active == "No") {
                  return (
                    <tr className="row-cancelled">
                      <td>{a.numero}</td>
                      <td>{fmtFecha(a.fecha)}</td>
                      <td>{a.clientes}</td>
                      <td>{a.area}</td>
                      <td>{a.vendedor}</td>
                      {/* <td>{a.departamentoName}</td> */}
                      <td>{a.paqueteria}</td>
                      <td></td>
                      {/* <td>{a.is_active == "Si" ? (
                        new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.total_general)
                          ) : undefined}
                      </td> */}
                      <td>CANCELADA</td>
                      <td>
                        <>
                          <Button
                            size="sm"
                            className="btn"
                            color="danger"
                            onClick={(e) =>
                              PDFOC(
                                a.fecha,
                                a.idClientes,
                                a.clientes,
                                a.observaciones,
                                a.observacionesPedido,
                                a.numero,
                                a._id,
                                a.user,
                                a.pedidos,
                                a.comisionTDC,
                                a.comisionFlete,
                                a.impuestos,
                                a.subTotal,
                                a.iva,
                                a.total_general,
                                a.calle,
                                a.numero_ext,
                                a.numero_int,
                                a.pais,
                                a.estado,
                                a.ciudad,
                                a.delegacion,
                                a.colonia,
                                a.cp,
                                a.RFC,
                                a.paqueteria,
                                a.area,
                                a.codigoClientes,
                                a.vendedor,
                                a.telefono,
                                a.creado,
                                a.fechaHora,
                                a.descuento,
                                a.is_active
                              )
                            }
                          >
                            <i className="far fa-file-pdf"></i>
                          </Button>
                          <Button
                            size="sm"
                            className="btn"
                            color="info"
                            onClick={(e) =>
                              PDFOCTicket(
                                a._id,
                                a.numero,
                                "VT"
                              )
                            }
                          >
                            <i className="fas fa-receipt"></i>
                          </Button>
                        </>
                      </td>
                    </tr>
                  );
                } else {
                  totalImporteTabla = totalImporteTabla + a.total_general;
                  return (
                    <tr>
                      <td>{a.numero}</td>
                      <td>{fmtFecha(a.fecha)}</td>
                      <td>{a.clientes}</td>
                      <td>{a.area}</td>
                      <td>{a.vendedor}</td>
                      {/* <td>{a.departamentoName}</td> */}
                      <td>{a.paqueteria}</td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.comisionFlete)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.total_general)}
                      </td>
                      <td>
                        <>
                          <Button
                            size="sm"
                            className="btn"
                            color="danger"
                            onClick={(e) =>
                              PDFOC(
                                a.fecha,
                                a.idClientes,
                                a.clientes,
                                a.observaciones,
                                a.observacionesPedido,
                                a.numero,
                                a._id,
                                a.user,
                                a.pedidos,
                                a.comisionTDC,
                                a.comisionFlete,
                                a.impuestos,
                                a.subTotal,
                                a.iva,
                                a.total_general,
                                a.calle,
                                a.numero_ext,
                                a.numero_int,
                                a.pais,
                                a.estado,
                                a.ciudad,
                                a.delegacion,
                                a.colonia,
                                a.cp,
                                a.RFC,
                                a.paqueteria,
                                a.area,
                                a.codigoClientes,
                                a.vendedor,
                                a.telefono,
                                a.creado,
                                a.fechaHora,
                                a.descuento,
                                a.is_active
                              )
                            }
                          >
                            <i className="far fa-file-pdf"></i>
                          </Button>
                          <Button
                            size="sm"
                            className="btn"
                            color="info"
                            onClick={(e) =>
                              PDFOCTicket(
                                a._id,
                                a.numero,
                                "VT"
                              )
                            }
                          >
                            <i className="fas fa-receipt"></i>
                          </Button>
                          <Button
                            size="sm"
                            className="btn"
                            color="success"
                            onClick={(e) => {
                              e.preventDefault();
                              setIdVenta(a._id);
                              setTelefono(a.telefono);
                              setNombre(a.nombre);
                              setCodigo(a.codigoClientes);
                              checkTrackingImage(a._id); // Check if tracking image exists
                              toggleTrackingModal();
                            }}
                          >
                            <i className="fas fa-truck-moving"></i>
                          </Button>
                          {user.cancelarNota ? (
                            <Button
                              size="sm"
                              className="btn"
                              color="danger"
                              onClick={(e) => cancelarNota(a._id)}
                            >
                              <i className="fas fa-ban"></i>
                            </Button>
                          ) : (
                            <Button
                              size="sm"
                              className="btn"
                              color="danger"
                              disabled
                            >
                              <i className="fas fa-ban"></i>
                            </Button>
                          )}
                         
                        </>
                      </td>
                    </tr>
                  );
                }
              })}
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita" align="center">
                  TOTAL
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(totalImporteTabla)}
                </td>
                <td></td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita" align="center">
                  TOTAL GENERAL
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(totalTotalTabla)}
                </td>
                <td></td>
              </tr>
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <Modal isOpen={modalTracking} toggle={toggleTrackingModal} size="sm">
        <ModalHeader toggle={toggleTrackingModal}>
          <h4>
            {trackingPhoto ? "Imagen de Tracking" : "Subir Imagen de Tracking"}
          </h4>
        </ModalHeader>

        <ModalBody>
          <Row>
            <Col className="text-center mb-3">
              {trackingPreviewUrl ? (
                <div className="preview-container">
                  {trackingFile && trackingFile.type === "application/pdf" ? (
                    <iframe
                      src={trackingPreviewUrl}
                      title="Vista previa de PDF"
                      className="w-100"
                      style={{ height: "250px", border: "1px solid #ccc" }}
                    />
                  ) : (
                    <img
                      src={trackingPreviewUrl}
                      alt="Vista previa de imagen"
                      className="img-fluid"
                      style={{ maxHeight: "250px", margin: "0 auto" }}
                    />
                  )}
                </div>
              ) : trackingPhoto ? (
                <div className="existing-image-container">
                  <img
                    src={trackingPhoto}
                    alt="Imagen de tracking"
                    className="img-fluid"
                    style={{ maxHeight: "250px", margin: "0 auto" }}
                  />
                </div>
              ) : (
                <div className="upload-placeholder p-4 border rounded">
                  <p className="mb-0">
                    Seleccione una imagen o PDF del número de tracking
                  </p>
                </div>
              )}
            </Col>
          </Row>

          <Row className="mt-2">
            <Col>
              <div className="custom-file">
                <input
                  type="file"
                  className="custom-file-input"
                  id="trackingImage"
                  accept="image/*,application/pdf"
                  onChange={handleTrackingFileChange}
                />
                <label
                  className="btn btn-outline-secondary w-100"
                  htmlFor="trackingImage"
                >
                  {trackingFile
                    ? trackingFile.name
                    : trackingPhoto
                    ? "Cambiar Archivo"
                    : "Seleccionar Imagen o PDF"}
                </label>
              </div>
            </Col>
          </Row>

          {trackingErrorMessage && (
            <Row className="mt-2">
              <Col>
                <div className="alert alert-danger" role="alert">
                  {trackingErrorMessage}
                </div>
              </Col>
            </Row>
          )}
        </ModalBody>

        <ModalFooter>
          <Button
            color="secondary"
            onClick={toggleTrackingModal}
            disabled={isTrackingUploading}
          >
            Cancelar
          </Button>
          {(!trackingPhoto || trackingFile) && (
            <Button
              color="primary"
              onClick={handleTrackingUpload}
              disabled={isTrackingUploading || !trackingFile}
            >
              {isTrackingUploading
                ? "Subiendo..."
                : trackingPhoto
                ? "Actualizar"
                : "Subir Imagen"}
            </Button>
          )}
        </ModalFooter>
      </Modal>
      <br />
      {loader}
    </>
  );
}

export default ListadoVentas;
